module.exports = __webpack_public_path__ + "img/image15.d36daa36.png";